var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12255 12.1094L19.6225 1.6093M9.25015 12.4374L11.8782 19.1954C12.1097 19.7908 12.2255 20.0884 12.3923 20.1753C12.5369 20.2507 12.7092 20.2508 12.8538 20.1756C13.0207 20.0889 13.1369 19.7914 13.3691 19.1963L19.9594 2.3085C20.1691 1.77132 20.2739 1.50273 20.2165 1.3311C20.1667 1.18205 20.0498 1.06508 19.9007 1.01529C19.7291 0.957962 19.4605 1.06277 18.9233 1.2724L2.03563 7.86274C1.44055 8.09497 1.14302 8.21108 1.05631 8.37798C0.981136 8.52267 0.981236 8.69495 1.05658 8.83955C1.14348 9.00635 1.44116 9.12205 2.0365 9.35365L8.79455 11.9818C8.91535 12.0288 8.97575 12.0523 9.02665 12.0886C9.07175 12.1207 9.11115 12.1602 9.14335 12.2053C9.17965 12.2561 9.20315 12.3166 9.25015 12.4374Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.29f16404176b6e798356127e385fceea.svg";
export { ForwardRef as ReactComponent };